// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"FormDisabledInfo_formGroup__xNuOc","formTitleError":"FormDisabledInfo_formTitleError__A951R"};